module.exports = __webpack_public_path__ + "img/xianchang.7e74f215.png";